"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Group: function() {
        return _FormInputGroup.FormInputGroup;
    },
    Prefix: function() {
        return _FormInputPrefix.FormInputPrefix;
    },
    Suffix: function() {
        return _FormInputSuffix.FormInputSuffix;
    }
});
const _FormInputGroup = require("./FormInputGroup");
const _FormInputPrefix = require("./FormInputPrefix");
const _FormInputSuffix = require("./FormInputSuffix");

//# sourceMappingURL=index.js.map